import React from 'react'
import Header4 from './../Common/Header4'
import Banner from './../Elements/Banner'
import WhatWeDo3 from './../Elements/WhatWeDo3'
import Services3 from './../Elements/Services3'
import Footer2 from '../Common/Footer2'


var bnrimg = require('./../../images/banner/1.jpg')

class MoreProduct extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script')
        script.src = src
        script.addEventListener('load', function () {
          resolve()
        })
        script.addEventListener('error', function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript('./assets/js/custom.js')
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="Askala Company"
            pagename="More Products"
            description="Building Foundations for Tomorrow" // "The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized."
            bgimage={bnrimg}
          />
          {/* <About2 /> */}
          {/* <Achievements1 /> */}
          {/* <SimilarProjects
            alignment="separator-center"
            title="Government Approval"
          /> */}
          <WhatWeDo3 />
          <Services3 />
          
          {/* <Team2 /> */}
          {/* <Testimonials2 separatoralignment="separator-center" /> */}
        </div>

        <Footer2 />
      </>
    )
  }
}

export default MoreProduct
